import { AccountSearchResult } from 'src/features/bulk/email/search/store/types';
import { SavedParameter } from 'src/features/clients/client/reportsV2/store/types';
import { GetFilteredClientEntity, ScheduledEvent, ScheduledEventInput } from 'src/features/reporting/store/types';

export interface SchedulerState {
  afsls: GetFilteredClientEntity[];
  groups: GetFilteredClientEntity[];
  clients: GetFilteredClientEntity[];
  practices: GetFilteredClientEntity[];
  advisers: GetFilteredClientEntity[];
  knownEntities: KnownFilterEntities;
  savedParametersList: SavedParameter[];
  editingEvent?: ScheduledEvent | null;
  savedParameter: SavedParameterWithAfsl | null;
  selectedTemplate?: EmailTemplate;
  accountSearchResult: AccountSearchResult[];
  allowStaticClients: boolean;
  afslTemplates: AfslTemplate[];
  practiceTemplates: PracticeTemplate[];
}

export type EntityLookup = Record<number, GetFilteredClientEntity>;

export interface KnownFilterEntities {
  afsls: EntityLookup;
  practices: EntityLookup;
  advisers: EntityLookup;
  groups: EntityLookup;
  clients: EntityLookup;
}

export interface SavedParameterWithAfsl {
  id: string;
  name: string;
  afslId: number;
}

export interface SchedulerParams {
  id?: string;
}

export interface ReportingParametersParams {
  id?: string;
}

export type SchedulerStep = 'schedule' | 'client' | 'report' | 'email';

export interface UpdateScheduledEventRequest {
  id: string;
  input: ScheduledEventInput;
}

export enum FromEmailAddressType {
  DASH = 'DASH',
  Adviser = 'Adviser',
}

export interface TemplatesRequest {
  entityCoreIds: number[];
}

export interface EmailTemplate {
  id: number;
  entityCoreId: number;
  templateName: string;
  templateText: string;
  emailSubject: string;
  attachments: EmailAttachmentTemplate[];
  isDeleted: boolean;
}

export interface AfslTemplate {
  afslTemplateId: number;
  entityCoreId: number;
  templateName: string;
  templateText: string;
  emailSubject: string;
  attachments: EmailAttachmentTemplate[];
  isDeleted: boolean;
}

export interface EmailAttachmentTemplate {
  attachmentTypeId: number;
  extension: number;
  fileName: string;
  id: number;
  name: string;
}

export interface PracticeTemplate {
  practiceTemplateId: number;
  entityCoreId: number;
  templateName: string;
  templateText: string;
  emailSubject: string;
  attachments: EmailAttachmentTemplate[];
  isDeleted: boolean;
}
